import { useEffect, useRef, useState } from "react";
import { sendEventToGA } from "../utils.js";

const COPIED_LABEL_MS = 3000;

/**
 * Blue "Copy to Clipboard" button that writes the given text to the
 * clipboard and reads "Copied" for three seconds afterwards.
 *
 * @param props.text Text to copy.
 * @param props.eventLabel Google Analytics event label for the copy.
 * @param props.eventType Optional GA event type (e.g. "datasets").
 * @param props.eventValue Optional GA event value (e.g. the dataset title).
 * @return JSX
 */
export function CopyToClipboardButton({ text, eventLabel, eventType, eventValue }) {
  const [copied, setCopied] = useState(false);
  const revertTimer = useRef(null);

  useEffect(() => () => clearTimeout(revertTimer.current), []);

  const copy = () => {
    sendEventToGA(eventLabel, eventType, eventValue);
    navigator.clipboard.writeText(text);
    setCopied(true);
    clearTimeout(revertTimer.current);
    revertTimer.current = setTimeout(() => setCopied(false), COPIED_LABEL_MS);
  };

  return (
    <button type="button" className="copyToClipboardButton" onClick={copy} aria-live="polite">
      {copied ? "Copied" : "Copy to Clipboard"}
    </button>
  );
}
